import { createSlice } from "@reduxjs/toolkit";

const intakeQueueSlice = createSlice({
  name: "intakeQueueSlice",
  initialState: {
    intakeQueueFilter: [],
  },
  reducers: {
    setIntakeQueueFilter: (state, action) => {
      state.intakeQueueFilter = action.payload;
    },
  },
});

export const { setIntakeQueueFilter } = intakeQueueSlice.actions;
export default intakeQueueSlice.reducer;
